export default function CollectionsHero() {
  return (
    <section className="relative h-72 md:h-96 flex items-end pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20furniture%20showroom%20wide%20angle%20view%20multiple%20premium%20pieces%20sofa%20dining%20table%20bed%20wardrobe%20dark%20wood%20warm%20golden%20lighting%20heritage%20elegance%20premium%20display%20arrangement&width=1920&height=600&seq=colhero&orientation=landscape"
          alt="Collections"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darkbrown/80 via-brand-darkbrown/40 to-brand-darkbrown/30" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <span className="font-display text-brand-gold text-xs tracking-[4px] uppercase block mb-3">M. Hayat &amp; Co.</span>
        <h1 className="font-serif text-5xl md:text-6xl text-white font-bold">Our Collections</h1>
        <p className="font-sans text-white/70 mt-3 text-sm max-w-lg leading-relaxed">
          Handcrafted furniture spanning eight distinguished categories — each piece a testament to 150+ years of expertise.
        </p>
      </div>
    </section>
  );
}
